import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa6'
import ModalNewCetificate from './ModalNewCetificate'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { getSettingCertificate } from '../../../services/setting/certificate'
import { fnDateEn } from '../../../helper/fnDateEn'
import { BsPencilSquare } from 'react-icons/bs'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import styled from 'styled-components'

import UseCertificateCategory from '../../../hooks/use-cer-category'
import UseCertificateGroup from '../../../hooks/use-cer-group'

export default function SettingCetificatePage() {
  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRows, setTotalRows] = useState(2)
  const [dataTable, setDataTable] = useState([])
  const [showModal, setShowModal] = useState({ isShow: false, data: null })
  const [bodyFilter, setBodyFilter] = useState()

  const optionCategory = UseCertificateCategory()
  const optionGroup = UseCertificateGroup()

  useEffect(() => {
    const body = {
      page: 1
    }
    fnGetData(body)
  }, [])

  const fnGetData = async (body) => {
    setBodyFilter(body)
    setIsLoading(true)
    const resp = await getSettingCertificate(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRows(resp.totalRows)
    } else {
      setTotalRows(0)
      setDataTable([])
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      page: 1,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      page: 1,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>Cetificate</TextNavTitle>
      </NavTitle>
      <CardCustom className="d-flex justify-content-between">
        <div>
          <div className="p-3">
            <Row>
              <Col md={4} className="my-auto small">
                <label>Total: {totalRows} </label>
              </Col>
              <Col md={8}>
                <BoxFilter className="justify-content-end">
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <Button
                    className="px-4 "
                    onClick={() => {
                      setShowModal({ isShow: true, data: null })
                    }}
                  >
                    <FaPlus className="me-2" />
                    New Cetificate
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">Cetificate</th>
                <th className="fw-normal">Group</th>
                <th className="fw-normal">Category</th>
                <th className="fw-normal">Brand</th>
                <th className="fw-normal">Cert Level</th>
                <th className="fw-normal">Pay Level</th>
                <th className="text-end fw-normal">Total</th>
                <th className="fw-normal ">Insert By</th>
                <th className="fw-normal text-center">Insert Date</th>
                <th className="text-center fw-normal">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={11} rowSpan={6} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => {
                  return (
                    <tr className="font-small-2 align-middle" key={i}>
                      <td> {page * totalLimits - totalLimits + i + 1}</td>

                      <td className="">{d.paymentNameCer}</td>
                      <td className="">{d.paymentCerGroup}</td>
                      <td className="">{d.paymentCertCategory}</td>
                      <td className="">{d.paymentCerBrand}</td>
                      <td className="">{d.paymentCerLevel}</td>
                      <td className="">{d.paymentLevel}</td>

                      <td className="text-end">
                        {d.paymentCerAmounts?.toLocaleString()}
                      </td>

                      <td className="">{d.insertBy}</td>
                      <td className="text-center">
                        {fnDateEn(d.insertDate).format('DD/MM/YYYY HH:mm')}
                      </td>
                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="light"
                          className="text-primary"
                          onClick={() => {
                            setShowModal({ isShow: true, data: d })
                          }}
                        >
                          <BsPencilSquare />
                        </Button>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr className="font-small-2 align-middle">
                  <td className="text-center" colSpan={11}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showModal.isShow && (
        <ModalNewCetificate
          optionCategory={optionCategory}
          optionGroup={optionGroup}
          data={showModal.data}
          fnGetData={() => {
            const body = {
              page: 1
            }
            fnGetData(body)
          }}
          onCancel={() => setShowModal({ isShow: false, data: null })}
          open={showModal.isShow}
        />
      )}
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }

  .btn-new {
    flex: 0 0 150px;
  }
`
